<div data-cy="subscription_block" class="box item-features item-features-left" [ngClass]="{ 'huge-margin-top': isFai }">
    @if (!isFai) {
        <span class="has-text-right block-actions">
            @if (showEdit) {
                <a
                    data-tc-action="Clic_redirection"
                    data-tc-categorie="Sortie_panier"
                    data-tc-clic="Modifier_forfait"
                    class="link has-text-secondary is-size-7"
                    [checkoutNavigateTo]="editUrl"
                >
                    Modifier
                </a>
            }
            <span class="is-invisible">ou</span>
            @if (showDeleteButton) {
                <a
                    data-tc-action="Clic_redirection"
                    data-tc-categorie="Sortie_panier"
                    data-tc-clic="Supprimer_forfait"
                    class="link has-text-secondary is-size-7"
                    (click)="remove()"
                >
                    Supprimer
                </a>
            }
        </span>
    }
    <ng-template checkoutSubscriptionBlockHost></ng-template>
</div>
